// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2vh2L","requiredAsterisk":"Info_requiredAsterisk__2yMXI"};